<template>
  <vv-screen-wrapper>
    <div class="screen-container">
      <div v-if="listBottlesRef.length > 0 ">
        <div class="title" v-if="$mq == 'desktop'">
          <div class="backButton">
            <img src="@/assets/next.svg" alt="" @click="$router.push({name: 'home'})">
          </div>
          <div>
            <div class="Wines">Les vins</div>
            <div class="nbrProduct"> {{`${listBottles.length} produits`}} </div>
          </div>
          <div>
            <span  @click="display = !display, displayTrie = false" class="side">Filtres</span>
            <div v-if="display == true" class="backgroundPopup" id="filtre" @click.self="display = false">
              <div class="selectType">
                <span class="boxTitle">FILTRER PAR</span>
                <div class="box">
                  <span>Type de vin</span>
                  <div class="type">
                    <div v-for="select in typeList" v-bind:key="select.type">
                      <div v-bind:class="chooseActive(select.isActive)" @click="selectType(select.type), select.isActive = !select.isActive"> {{select.type}} </div>
                    </div>
                  </div>
                </div>
                <div class="box">
                  <span>Régions</span>
                  <div class="type">
                    <div v-for="select in regionList" v-bind:key="select.region">
                      <div v-bind:class="chooseActive(select.isActive)" @click="selectRegion(select.region), select.isActive = !select.isActive"> {{select.region}} </div>
                    </div>
                  </div>
                </div>
                <div class="box">
                  <span>Millésime</span>
                  <div class="type">
                    <div v-for="select in millesimeList" v-bind:key="select.millesime">
                      <div v-bind:class="chooseActive(select.isActive)" @click="selectMillesime(select.millesime), select.isActive = !select.isActive"> {{select.millesime}} </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="valide" @click="display = false">Valider les filtres</div>
            </div>
          </div>
          <span class="side" @click="displayTrie = !displayTrie, display = false">Trier par</span>
          <div v-if="displayTrie == true" class="backgroundPopup" @click.self="displayTrie = false">
            <div class="selectType">
              <span class="boxTitle">TRIER PAR</span>
              <div class="box">
                <div class="typeTri">
                  <div v-for="select in triList" v-bind:key="select.type">
                    <div v-bind:class="chooseActive(select.isActive)" @click="selectTrie(select.type), select.isActive = !select.isActive"> {{select.type}} </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="valideType" @click="displayTrie = false">Valider le tris</div>
          </div>
        </div>
        <div v-else :class="[`title-${$mq}`]">
          <div class="titleFirstBlock">
            <div class="backButton">
              <img src="@/assets/next.svg" alt="" @click="$router.push({name: 'home'})">
            </div>
            <div>
              <div class="Wines">Les vins</div>
              <div class="nbrProduct"> {{`${listBottles.length} produits`}} </div>
            </div>
          </div>
          <div class="titleSegondBlock">
            <div>
              <span  @click="display = !display, displayTrie = false" class="side">Filtres</span>
              <div v-if="display == true" class="backgroundPopup" id="filtre" @click.self="display = false">
                <div class="selectType-mobile">
                  <span class="boxTitle-mobile">FILTRER PAR</span>
                  <div class="box-mobile">
                    <span>Type de vin</span>
                    <div class="type">
                      <div v-for="select in typeList" v-bind:key="select.type">
                        <div v-bind:class="chooseActiveMobile(select.isActive)" @click="selectType(select.type), select.isActive = !select.isActive"> {{select.type}} </div>
                      </div>
                    </div>
                  </div>
                  <div class="box-mobile">
                    <span>Régions</span>
                    <div class="type">
                      <div v-for="select in regionList" v-bind:key="select.region">
                        <div v-bind:class="chooseActiveMobile(select.isActive)" @click="selectRegion(select.region), select.isActive = !select.isActive"> {{select.region}} </div>
                      </div>
                    </div>
                  </div>
                  <div class="box-mobile">
                    <span>Millésime</span>
                    <div class="type">
                      <div v-for="select in millesimeList" v-bind:key="select.millesime">
                        <div v-bind:class="chooseActiveMobile(select.isActive)" @click="selectMillesime(select.millesime), select.isActive = !select.isActive"> {{select.millesime}} </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="valide" @click="display = false">Valider les filtres</div>
              </div>
            </div>
            <span class="side" @click="displayTrie = !displayTrie, display = false">Trier par</span>
          </div>
          <div v-if="displayTrie == true" class="backgroundPopup" @click.self="displayTrie = false">
            <div class="selectType-mobile">
              <span class="boxTitle-mobile">TRIER PAR</span>
              <div class="box">
                <div class="typeTri">
                  <div v-for="select in triList" v-bind:key="select.type">
                    <div v-bind:class="chooseActiveMobile(select.isActive)" @click="selectTrie(select.type), select.isActive = !select.isActive"> {{select.type}} </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="valideType" @click="displayTrie = false">Valider le tris</div>
          </div>
        </div>
        <div class="body-top">
          <mq-layout :mq="['mobile', 'tablet']" class="listBottel">
            <div class="link-wrapper" v-for="tasting in listBottles" :key="tasting.id">
              <tasting-list-item :id="tasting.id" />
            </div>
          </mq-layout>

          <mq-layout :mq="['desktop']" class="listBottel">
            <div class="desktop-tasting-item-wrapper" v-for="tasting in listBottles" :key="tasting.id">
              <tasting-list-item :id="tasting.id" />
            </div>
          </mq-layout>
        </div>
      </div>
      <div v-else :class="{ 'NoTastings': true, 'NoTastings--small': ['mobile', 'tablet'].includes(this.$mq)}">
        <div class="MainContainer">
          <div class="Title">{{ $t('tasting.no-wines.title') }}</div>
          <div class="Subtitle">{{ $t('tasting.no-wines.subtitle') }}</div>
          <div class="Cta">
            <vv-button customClass="primary-variant" @click="$router.push({ name: 'shop-list-bottles'})">{{ $t('tasting.no-wines.cta-shop') }}</vv-button>
          </div>
          <mq-layout :mq="['desktop']" v-if="bottleItems.length > 0">
            <div class="ShopListBottle">Exemple de bouteille de la Boutique:</div>
            <div class="listBottle">
              <div v-for="bottle of bottleItems" :key="bottle.id" class="Bottle">
                <img :src="bottle.image" class="imgBottle">
                <div class="titleBottle"> {{bottle.title}} </div>
                <div class="Infos">
                  <div class="Naming-Container">
                    <span>{{ bottle.details.naming}}</span>
                    <span>{{ bottle.details.region }}</span>
                  </div>
                  <div class="Years-Container">
                    <span>{{ bottle.details.type }}</span>
                    <span>{{ bottle.details.millesime }}</span>
                  </div>
                  <div class="Domain-Container">
                    <span>{{ bottle.details.domainName }}</span>
                  </div>
                  <div class="Price-Container">
                    <span>{{ bottle.price }} €</span>
                  </div>
                </div>
              </div>
            </div>
          </mq-layout>
        </div>
        <div class="Illustration">
          <img src="@/assets/vino-degust-empty@2x.png" />
        </div>
      </div>
    </div>
  </vv-screen-wrapper>
</template>

<script>
import { mapGetters } from 'vuex'

import _ from 'lodash'

import userMixin from '@/mixins/user'
import contentMixin from '@/mixins/content'

import VvScreenWrapper from '@/components/common/VvScreenWrapper'
import VvButton from '@/components/common/VvButton'
import SimpleHeader from '@/components/navigation/SimpleHeader'
import TastingListItem from '@/components/tasting/TastingListItem'
import shopMixin from '@/mixins/shop'

export default {
  name: 'TastingList',
  components: { TastingListItem, SimpleHeader, VvScreenWrapper, VvButton },
  mixins: [contentMixin, shopMixin],
  data() {
    return {
      display: false,
      displayTrie: false,
      typeItems: [],
      regionItem: [],
      millesimeItems: [],
      triList: [
        {type: 'Prix croissant', isActive: false},
        {type: 'Prix décroissant', isActive: false}
      ],
      typeList: [
        {type: 'Rosé', isActive : false},
        {type: 'Rouge', isActive : false},
        {type: 'Blanc', isActive : false},
        {type: 'Effervescent', isActive : false},
        {type: 'Effervescent rosé', isActive : false}
      ],
      regionList: [
        {region: 'Bourgogne', isActive : false},
        {region: 'Bordeaux', isActive : false},
        {region: 'Languedoc', isActive : false},
        {region: 'Sud-Ouest', isActive : false},
        {region: 'Beaujolais', isActive : false},
        {region: 'Roussillon', isActive : false},
        {region: 'Loire', isActive : false},
        {region: 'Savoie', isActive : false},
        {region: 'Champagne', isActive : false},
        {region: 'Provence', isActive : false},
        {region: 'Piémont', isActive : false},
        {region: 'Vallée du Rhône', isActive : false}
      ],
      millesimeList: [
        {millesime: '2020', isActive: false},
        {millesime: '2019', isActive: false},
        {millesime: '2018', isActive: false},
        {millesime: '2017', isActive: false},
        {millesime: '2016 et -', isActive: false},
      ]
    }
  },
  computed: {
    ...mapGetters({ getTastings: 'getTastings', themes: 'getThemes', bottleId: 'getBottleById', getTastingById: 'getTastingById' }),
    bottleItems() {
      const bottles = []
      let alreadyPushed = []
      for (const bottle of this.bottles) {
        if (alreadyPushed.indexOf(bottle.id) == -1) {
          const splitTitle = bottle.title.split('||')
          const title = splitTitle[0]
          const description = splitTitle[1]

          const base = {
            title,
            id: bottle.id
          }
          
          bottles.push(
            Object.assign({}, base, {
              description,
              price: Number(bottle.variants[0].price),
              soldOut: !bottle.variants[0].available,
              contentfulId: bottle.variants[0].sku,
              image: bottle.images[0].src,
              details: this.bottleId(bottle.variants[0].sku)
            })
          )
          alreadyPushed.push(bottle.id)
        }
      }
 
      let tmp = bottles.slice(0)
      let bott = []
      while (bott.length < 5) {
        bott.push(tmp.splice(Math.floor(Math.random()*tmp.length), 1)[0])
      }
      return bott
    },
    listBottles() {
      let myTastingList = []
      let pushElemId = []
      let themes = this.themes.filter(t => t.tastings.length > 0 && this.hasAccessToContent(t.id))
      themes.forEach(theme => {
        let tastings = this.getTastings.filter(t => Object.values(_.mapValues(theme.tastings, 'id')).includes(t.id))

        for (let x = 0; tastings.length > 0 && x < tastings.length; x +=1) {
          if (pushElemId.indexOf(tastings[x].id) == -1) {
            myTastingList.push(tastings[x])
            pushElemId.push(tastings[x].id)
          }
        }
      })
      for (let i = 0; i < myTastingList.length; i++) {
        myTastingList[i].price = this.selectPrice(myTastingList[i].bottleName)
      }
      for (let i = 0; i < myTastingList.length; i++) {
        const details = this.bottleId(myTastingList[i].bottleId)
        myTastingList[i].details = details
      }
      if (this.typeItems.length != 0) {
        for (let i = 0; i < myTastingList.length; i++) {
          var select = 0
          for (let index = 0; index < this.typeItems.length; index++) {
            if (this.typeItems[index] == myTastingList[i].details.type) {
              select = 1
            }
          }
          if (select == 0) {
            myTastingList.splice(i, 1)
            i -= 1
          }
        }
      }
      if (this.regionItem.length != 0) {
        for (let i = 0; i < myTastingList.length; i++) {
          var select = 0
          for (let index = 0; index < this.regionItem.length; index++) {
            if (this.regionItem[index] == myTastingList[i].details.region) {
              select = 1
            }
          }
          if (select == 0) {
            myTastingList.splice(i, 1)
            i -= 1
          }
        }
      }
      if (this.millesimeItems.length != 0) {
        for (let i = 0; i < myTastingList.length; i++) {
          var select = 0
          for (let index = 0; index < this.millesimeItems.length; index++){
            if (this.millesimeItems[index] == myTastingList[i].details.millesime) {
              select = 1
            }
            if (this.millesimeItems[index] == "2016 et -") {
              let annee = myTastingList[i].details.millesime
              if (annee <= 2016) {
                select = 1
              }
            }
          }
          if (select == 0) {
            myTastingList.splice(i, 1)
            i -= 1
          }
        }
      }
      return myTastingList
    },
    listBottlesRef() {
      let myTastingList = []
      let pushElemId = []
      let themes = this.themes.filter(t => t.tastings.length > 0 && this.hasAccessToContent(t.id))
      themes.forEach(theme => {
        let tastings = this.getTastings.filter(t => Object.values(_.mapValues(theme.tastings, 'id')).includes(t.id))

        for (let x = 0; tastings.length > 0 && x < tastings.length; x +=1) {
          if (pushElemId.indexOf(tastings[x].id) == -1) {
            myTastingList.push(tastings[x])
            pushElemId.push(tastings[x].id)
          }
        }
      })
      for (let i = 0; i < myTastingList.length; i++) {
        myTastingList[i].price = this.selectPrice(myTastingList[i].bottleName)
      }
      return myTastingList
    }
  },
  methods: {
    openBottle(bottleId) {
      this.$router.push({
        name: 'shop-full-bottle',
        params: {
          productId: bottleId
        }
      })
    },
    selectTrie(variable) {
      if (variable == 'Prix croissant') {
        this.triList[1].isActive = false
        this.listBottles.sort(function(a, b) {
          return a.price - b.price
        })
      } else {
        this.triList[0].isActive = false
        this.listBottles.sort(function(a, b) {
          return a.price - b.price
        })
        this.listBottles.reverse()
      }
    },
    selectPrice(titles) {
      for (let bottle of this.bottles) {
        const splitTitle = bottle.title.split('||')
        const title = splitTitle[0]
        if (titles == title) {
          return Number(bottle.variants[0].price)
        }
      }
    },
    selectRegion(variable) {
      if (this.regionItem.indexOf(variable) !== -1) {
        for (let i = 0; i < this.regionItem.length; i++) {
          if (this.regionItem[i] == variable) {
            this.regionItem.splice(i, 1)
          }
        }
      } else {
        this.regionItem.push(variable)
      }
    },
    selectType(variable) {
      if (this.typeItems.indexOf(variable) !== -1) {
        for (let i = 0; i < this.typeItems.length; i++) {
          if (this.typeItems[i] == variable) {
            this.typeItems.splice(i, 1)
          }
        }
      } else {
        this.typeItems.push(variable)
      }
    },
    selectMillesime(variable) {
      if (this.millesimeItems.indexOf(variable) !== -1) {
        for (let i = 0; i < this.millesimeItems.length; i++) {
          if (this.millesimeItems[i] == variable) {
            this.millesimeItems.splice(i, 1)
          }
        }
      } else {
        this.millesimeItems.push(variable)
      }
    },
    chooseActive(active) {
      return active == true ? "objet active" : "objet"
    },
    chooseActiveMobile(active) {
      return active == true ? "objet-mobile active" : "objet-mobile"
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.body-top {
  margin: 50px 0px;
}
.Wines {
  font-size: 30px;
  font-weight: 700;
}
.backgroundPopup {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  position: fixed;
  top: 0px;
  left: 0px;
  z-index: 100;
  background-color: #e5e6f563;
  width: 100%;
  height: 100%;
  align-items: center;
  justify-content: flex;
}
.valideType {
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  font-size: 15px;
  height: auto;
  width: 90px;
  border: solid 1px rgba(209,10,74,255);
  border-radius: 20px;
  color: white;
  background-color: rgba(209,10,74,255);
  cursor: pointer;
  margin: -20px 0px;
}
.valide {
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 6px 12px;
  font-size: 15px;
  height: auto;
  width: 120px;
  border: solid 1px rgba(209,10,74,255);
  border-radius: 20px;
  color: white;
  background-color: rgba(209,10,74,255);
  cursor: pointer;
  margin: -20px 0px;
}
.nbrProduct {
  margin-top: 2px;
  font-size: 13px;
}
.boxTitle {
  position: relative;
  left: 40%;
  margin-top: 15px;
  font-size: 130%;
  font-weight: 200;
}
.boxTitle-mobile {
  font-size: 100%;
  font-weight: 200;
}
.objet {
  border: solid 1px rgba(209,10,74,255);
  border-radius: 20px;
  padding: 2px 15px;
  margin: 8px 10px;
  cursor: pointer;
}
.active {
  color: white;
  background-color: rgba(209,10,74,255);
}

.objet-mobile {
  border: solid 1px rgba(209,10,74,255);
  border-radius: 20px;
  padding: 2px 15px;
  margin: 8px 10px;
  cursor: pointer;
  &:active {
    color: white;
    background-color: rgba(209,10,74,255);
  }
}
.typeTri {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
}
.type {
  display: flex;
  flex-wrap: wrap;
}
.box {
  margin: 15px;
  font-size: 20px;
}
.box-mobile {
  margin: 5px;
  font-size: 15px;
}
.selectType {
  padding: 30px;
  width: 35%;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  border: solid 2px $primary-alt;
  background-color: $primary-alt;
  border-radius: 20px;
  box-shadow: 0px 0px 5px 5px #b3b2b2;
  -webkit-box-shadow: 0px 0px 10px 0px #b3b2b2;
  -moz-box-shadow: 0px 0px 10px 0px #b3b2b2;  
}
.selectType-mobile {
  overflow: auto;
  padding: 20px;
  z-index: -5;
  width: 85%;
  display: flex;
  text-align: center;
  flex-direction: column;
  justify-content: space-evenly;
  border: solid 2px $primary-alt;
  background-color: $primary-alt;
  border-radius: 20px;
  box-shadow: 0px 0px 5px 5px #b3b2b2;
  -webkit-box-shadow: 0px 0px 10px 0px #b3b2b2;
  -moz-box-shadow: 0px 0px 10px 0px #b3b2b2;  
}
.side {
  // color: $primary;
  display: flex;
  justify-content: center;
  width: 80px;
  height: auto;
  cursor: pointer;
  font-size: 17px;
  background-color: #F9FAFF;
  box-shadow:  3px 3px 3px #bebebe,
              -3px -3px 1px #ffffff;
  opacity: 1;
  padding: 3px 3px;
  border-radius: 20px;
  &:hover {
  box-shadow:  -3px -3px 3px #bebebe,
              3px 3px 1px #ffffff;
  }
}
.title {
  align-items: center;
  font-size: auto;
  font-weight: 150;
  display: flex;
  width: 400px;
  margin-left: 20px;
  margin-bottom: 20px;
  // margin-right: 33%;
  margin-top: 10px;
  flex-direction: row;
  justify-content: space-between;
}
.title-mobile, .title-tablet {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.title-tablet {
  flex-direction: row;
  justify-content: space-evenly;
}

.title-mobile {
  flex-direction: column;
}

.titleSegondBlock {
  display: flex;
  flex-direction: row;
  align-items: center;
}

.title-mobile > .titleSegondBlock {
  margin-top: 20px;
}

.titleSegondBlock > div {
  margin: 0px 10px;
}

.titleFirstBlock {
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
}

.titleFirstBlock > .backButton{
  margin: 0px 50px 0px 20px ;
}

.screen-container {
  display: flex;
  align-items: center;
}
.ShopListBottle{
  margin-top: 40px;
  font-weight: 700;
  text-align: center;
}
.Infos {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: smaller;
  padding: 0 10px;
  box-sizing: border-box;
  margin-top: 5px;
  text-align: center;

  .Naming-Container {
    font-style: italic;
    font-size: x-small;

    .Naming {
      margin-right: 10px;
    }
    .Region {
      margin-left: 10px;
    }
    .Naming-Mobile {
      font-size: xx-small;
    }
    .Region-Mobile {
      display: none;
    }
    .Sep-Mobile {
      display: none;
    }
  }
  
  .Years-Container {
    font-style: italic;
    font-size: x-small;

    .Type {
      margin-right: 10px;
    }
    .Years {
      margin-left: 10px;
    }

    .Type-Mobile {
      display: none;
    }

    .Years-Mobile {
      display: none;
    }
    
    .Sep-Mobile {
      display: none;
    }
  }

  .Domain-Container {
    font-size: small;

    .Domain-Mobile {
      font-size: xx-small;
    }
  }

  .Price-Container {
    color: black;
    font-weight: bolder;

    .Original-Price {
      text-decoration: line-through;
      margin-right: 10px;
    }
    .Original-Price-Mobile {
      text-decoration: line-through;
      margin-right: 10px;
      font-size: small;
    }

    .Price-Mobile {
      font-size: x-small;
    }
    
  }
}
.price{
  font-size: 10px;
}
.titleBottle {
  font-weight: 700;
}
.Bottle{
  margin: 10px;
  text-align: center;
}
.imgBottle{
  width: 100%;
  border-radius: 23px;
  // margin: 50px;
}
.listBottle{
  display: flex;
  flex-direction: row;
}
.link-wrapper {
  margin: 10px 10px;
}

.desktop-tasting-item-wrapper {
  margin: 0px 10px 45px 10px;
}

.NoTastings {
  position: relative;
  top: 100px;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .MainContainer {
    width: 60%;
    display: flex;
    justify-content: center;
    flex-direction: column;
    align-items: center;
    // padding-left: 200px;
    position: relative;
    bottom: 50px;

    .Title {
      font-size: 2rem;
      font-family: Helvetica, sans-serif;
      margin-bottom: 57px;
      text-align: center;
    }

    .Subtitle {
      font-size: 1rem;
      font-family: Helvetica, sans-serif;
      margin-bottom: 30px;
      text-align: center;
    }

    .Cta {
      display: flex;
      margin-left: auto;
      margin-right: auto;
      justify-content: space-evenly;
      align-items: center;

      > * {
        font-size: 0.8rem;
        margin-left: 30px;
        margin-right: 30px;
      }
    }
  }

  .Illustration {
    width: 30%;

    img {
      width: 100%;
      height: auto;
    }
  }

  &--small {
    flex-direction: column;

    .MainContainer {
      bottom: -50px;
      width: 80%;

      .Title {
        font-size: 1.75rem;
      }

      .Cta {
        flex-direction: column;
        
        & > * {
          margin-left: 0;
          margin-right: 0;
          margin-bottom: 30px;
        }
      }
    }

    .Illustration {
      margin-top: 20px;
      width: 70%;
      overflow-y: hidden;
    }
  }
}

.backButton {
  cursor: pointer;
  background-color: #F5F6FF;
  height: 55px;
  width: 55px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50px;
  box-shadow:  3px 3px 3px #bebebe,
             -4px -4px 4px #ffffff;
  img {
    height: 60%;
    width: 60%;
    margin-right: 4px;
    transform: rotate(180deg);
  }
  &:hover {
  box-shadow:  -3px -3px 4px #bebebe,
             3px 3px 2px #ffffff;
  }
}

.listBottel {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  flex-direction: row;
}
</style>
